import * as angular from 'angular';
import { StateParams } from '@uirouter/core';

import { HeaderInfo } from './HeaderInfo';

import { IAuthenticationService, IConfigurationService, ISessionStorageService } from '../../services/general';
import { workspaceKey } from '../../common/constants';
import { getTimeZone } from '../../common/getTimezone';

export interface IHeaderInfoService {
    getHeaderInfos(): angular.IPromise<HeaderInfo>;
}

export class HeaderInfoService implements IHeaderInfoService {
    static serviceId = 'headerInfoService';

    static $inject = [
        '$stateParams',
        'authenticationService',
        'configurationService',
        'sessionStorageService'
    ];
    constructor(private _$stateParams: StateParams,
        private _authenticationService: IAuthenticationService,
        private _configurationService: IConfigurationService,
        private _sessionStorageService: ISessionStorageService) {
    }

    getHeaderInfos(): angular.IPromise<HeaderInfo> {
        const beginDate = this._$stateParams['beginDate'];
        const endDate = this._$stateParams['endDate'];
        
        // Decode URI-encoded dates if necessary
        const decodedBeginDate = beginDate ? decodeURIComponent(beginDate) : beginDate;
        const decodedEndDate = endDate ? decodeURIComponent(endDate) : endDate;
        
        return this._configurationService.getLogoFileName()
            .then(data => {
                return {
                    beginDate: new Date(decodedBeginDate),
                    endDate: new Date(decodedEndDate),
                    application: JSON.parse(this._sessionStorageService.getFrom(workspaceKey)).application,
                    logoFileName: data,
                    userName: this._authenticationService.authentication.userName,
                    timeZone: getTimeZone()
                };
            });
    }
}